export const NOTIFICATION_CREATE_REQUEST = 'misc/NOTIFICATION_CREATE_REQUEST';
export const LOADING_BAR_DISPLAY_REQUEST = 'misc/LOADING_BAR_DISPLAY_REQUEST';
export const MESSAGE_MODAL_CREATE_REQUEST = 'misc/MESSAGE_MODAL_CREATE_REQUEST';
